import React, { Component } from 'react';
import { Typography, Tooltip, Popconfirm } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { showNumber } from '../statusConfig';
import { amountToString } from '../../../util/tool';
import RenderPopover from '../../../components/RenderPopover';
import './renderlist.less';

export default class RenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleConfig: [
        {
          "name": "商品",
          "rolWidth": 1
        },
        {
          "name": "价格",//价格(元)-老版计划单优化取消价格以及币种符号
          "rolWidth": 1
        },
        {
          "name": "税率",
          "rolWidth": 1
        },
        {
          "name": "商品价格(含税)",
          "rolWidth": 1
        },
        {
          "name": "数量",
          "rolWidth": 1
        },
        {
          "name": "总金额",//总金额(元)
          "rolWidth": 1
        },
        {
          "name": "订单状态",
          "rolWidth": 1
        },
        // {
        //   "name": "交易操作",
        //   "rolWidth": 1
        // }
      ]
    };
  }

  renderDetail = (info) => {
    if (!info) return;
    const parseInfo = JSON.parse((info));
    const surcharge_desc = !info ? [] : parseInfo;
    const record = { qoute: { surcharge_desc } };
    return <RenderPopover record={record} />;
  }

  render() {
    const { titleConfig = [] } = this.state;
    const { formateList = [], toOrderDetail, toOrderAgain, expandFn, onHandlerSpot, toProductDetail, cancelOrder } = this.props;
    return (
      <div className='render-list-container'>
        <div className='render-list-title'>{titleConfig.map((item, index) => <div className={index < titleConfig.length - 2 ? (index > 0 ? 'render-list-title-item-normal1' : 'render-list-title-item') : 'render-list-title-item-normal4'} key={index}>{item.name}</div>)}</div>
        <div className='render-list-content'>
          {
            formateList.map(item => {
              return (
                <div className='render-list-content-container' key={item.orderId}>
                  <div className='render-list-content-title'>
                    <div>订单号：{item.orderNo}</div>
                    <div>下单时间：{item.createTime}</div>
                    <div>
                      <span className='service pointer' onClick={() => onHandlerSpot(item)}></span>
                      <Tooltip title={item.supplier}>{item?.supplier?.length > 10 ? item?.supplier?.slice(0, 10) + '...' : item?.supplier} </Tooltip>
                    </div>
                    <div>期望到货日期：{item.expectedDate}</div>
                  </div>
                  <div className='render-list-content-products-container'>
                    <div className='render-list-content-products-container-left'>
                      {item.saleList.slice(0, item.isExpand ? showNumber : item.saleList.length).map((subItem, subIndex) => (
                        <div className='render-list-content-products-item' key={subIndex}>
                          <div className='render-list-content-detail'>
                            <div className='render-list-content-detail-product'>
                              <div className='render-list-content-detail-product-left'><img src={subItem.product_img} alt="" /></div>
                              <div className='render-list-content-detail-product-right'>
                                <div className='pointer render-list-content-detail-product-right-title' onClick={() => toProductDetail(subItem)}>{subItem.sku_name}</div>
                                <div>规格：{subItem.sale_norms}</div>
                              </div>
                            </div>
                            {/* ¥ {`${subItem.sale_price} / ${subItem.sale_unit}`}*/}
                            <div className='render-list-content-detail-item'> {`${subItem.sale_price} / ${subItem.sale_unit}`}</div>
                            <div className='render-list-content-detail-item'>{subItem.tax_rate >= 0 ? (+subItem.tax_rate + '%') : '-'}</div>
                            <div className='render-list-content-detail-item'>
                              {/* ￥{amountToString(subItem.tax_inclusive_price)} */}
                              <div style={{ display: 'flex', justifyContent: 'center' }}>{subItem.tax_inclusive_price === '-' ? '' : <>{amountToString(subItem.tax_inclusive_price)}</>} {this.renderDetail(subItem.surcharge_desc)}</div>                            </div>
                            <div className='render-list-content-detail-item'>{(+subItem.sale_number) + ' ' + subItem.sale_unit}</div>
                          </div>
                        </div>
                      ))}

                      {item.saleList.length > showNumber ?
                        <div className='render-list-content-expand pointer' onClick={() => expandFn(item)}>
                          {item.isExpand ? <span><span>共<Typography.Link>{item.saleList.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
                        </div> : null}
                    </div>
                    <div className='render-list-content-products-container-right'>
                      {/* ¥ {amountToString(item.tax_inclusive_real_price)} */}
                      <div className='render-list-content-products-container-right-item'> {amountToString(item.tax_inclusive_real_price)}</div>
                      <div className='render-list-content-products-container-right-item'>
                        <div><Typography.Link style={{ color: '#1890FF', textDecoration: 'none' }} >{item.statusText}</Typography.Link></div>
                        {/* <Button type='primary' style={{ marginTop: 5 }} onClick={() => { cancelOrder(item); }}>取消订单</Button>
                        <Button type='primary' style={{ marginTop: 5 }} onClick={() => { toOrderDetail(item); }}>订单详情</Button>
                        <Button type='primary' style={{ marginTop: 5 }} onClick={() => { toOrderAgain(item); }}>再来一单</Button> */}
                        {item.orderStatus === 5 && <div className='pointer' style={{ color: (item.orderStatus === 5 ? '#007AFF' : '#000') }}><Popconfirm title='确定取消订单?' onConfirm={() => { cancelOrder(item); }}><Typography.Link>{item.buttonText}</Typography.Link></Popconfirm></div>}
                        <div className='pointer' onClick={() => { toOrderDetail(item); }}><Typography.Link>订单详情</Typography.Link></div>
                        <div className='pointer' onClick={() => { toOrderAgain(item); }}><Typography.Link>再来一单</Typography.Link></div>
                        {/* {((item.deliveryType === '3' || item.deliveryType === 3) && (item.orderStatus === 30 || item.orderStatus === 40)) ? <div className='pointer' style={{ marginTop: 8 }}><span onClick={() => { handleLogistics(item); }}>查看物流</span></div> : null} */}
                      </div>
                      {/* <div className='render-list-content-products-container-right-item'>
                        <div className='pointer' style={{ color: (item.orderStatus === 30 ? '#007AFF' : '#000') }}>
                          <Popconfirm title='确定取消订单' onConfirm={() => { btnClicked(item); }}>
                            <Typography.Link>{item.buttonText}</Typography.Link>
                          </Popconfirm>
                          {(item.orderStatus === 30) && <Popconfirm title={`确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}?`} onConfirm={() => { changeStatus(item); }}>
                            <Typography.Link>{statusToButtonsConfirmed[buttonsConfirmedStatus]}</Typography.Link>
                          </Popconfirm>}
                          {item.isInformation === 0 ? <div onClick={() => perfectInformation(item)}><Typography.Link>完善收货信息</Typography.Link></div> : null}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
